import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { ProductSearchComponent } from './product-search/product-search.component';

@NgModule({
    declarations: [
        ProductSearchComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [
        ProductSearchComponent,
    ],
    // providers: [
    //     Store,
    // ],
})
export class ProductModule {
}
